import { PaginatedHierarchyItemsDataStore } from '@stores/paginated-hierarchy-items/PaginatedHierarchyItemsDataStore'
import PaginatedTableHierarchyItemsUIStore from '@stores/paginated-table-hierarchy-items/PaginatedTableHierarchyItemsUIStore'
import { createContext } from 'react'

const HierarchyItemsTableContext = createContext<{
  store: PaginatedTableHierarchyItemsUIStore<PaginatedHierarchyItemsDataStore>
}>({ store: null })

HierarchyItemsTableContext.displayName = 'HierarchyItemsTableContext'

export default HierarchyItemsTableContext
